const img1 = require("../images/slider/slide_01.png")
const img2 = require("../images/slider/slide_02.png")
const img3 = require("../images/slider/slide_03.png")

const sliderData = [
    {
        title: "Áo Polo kẻ ngang",
        description: "Khác biệt hoàn toàn với áo thun cổ tròn, khi mặc áo thun polo sẽ giúp bạn có được vẻ đẹp sang trọng, lịch sự từ đó toát lên được nét trẻ trung, năng động cho người mặc.",
        img: img1,
        color: "red",
        path: "/catalog/polo_shirt_01"
    },
    {
        title: "Áo Polo cổ khóa",
        description: "Nếu bạn là người có thân hình cân đối với chiều cao và cân nặng lý tưởng thì đây là kiểu áo thời thượng mà bạn không nên bỏ qua cho mình trong quá trình sử dụng.",
        img: img2,
        path: "/catalog/t_shirt_04",
        color: "black"
    },
    {
        title: "Áo sơ mi trắng",
        description: "Chiếc áo sơ mi giờ đây đã vượt lên hẳn ý nghĩa của một trang phục thông thường để trở thành nét văn hóa của con người hiện đại. Đó là văn hóa của hội nhập, của hiện đại và sự thanh lịch. Giờ đây, sơ mi cũng là văn hóa.",
        img: img3,
        path: "/catalog/shirt_03",
        color: "white"
    }
]

export default sliderData